import { FaIcon } from './FaIcon'

import styles from './GreenCheckIcon.module.scss'

export const GreenCheckIcon = () => (
  <FaIcon className={styles.saved} icon="fa-check" />
)
